import { useEffect, useMemo, useState } from "react";
import * as Scrivito from "scrivito";
import { getHomepage } from "utils";
import { useProjectActions } from "stores/project/project/projectStore";

type NavigateToProject = {
  item: (projectId: string) => void;
  configurator: (projectId: string) => void;
};

export const useNavigateToProject = () => {
  const { set: setProject } = useProjectActions();
  const [homepage, setHomepage] = useState<Scrivito.Obj>();

  useEffect(() => {
    Scrivito.load(() => {
      const response = getHomepage() as Scrivito.Obj;
      if (!response) {
        console.warn(
          "An error occured whilst fetching the Scrivito homepage Obj...",
        );
      }
      setHomepage(response);
    });
  }, []);

  const projectConfiguratorObj = homepage?.get(
    "projectConfiguratorPage",
  ) as Scrivito.Obj;
  const projectItemObj = homepage?.get("projectItemPage") as Scrivito.Obj;
  const navigateToProject: NavigateToProject = useMemo(
    () => ({
      item: (projectId: string) => {
        if (!projectItemObj) {
          console.error("ProjectItem Obj is not defined");
          return;
        }
        setProject(projectId);
        Scrivito.navigateTo(projectItemObj, {
          params: {
            projectId,
          },
        });
      },
      configurator: (projectId: string) => {
        if (!projectConfiguratorObj) {
          console.error("ProjectItem Obj is not defined");
          return;
        }
        setProject(projectId);
        Scrivito.navigateTo(projectConfiguratorObj, {
          params: {
            projectId,
          },
        });
      },
    }),
    [projectItemObj, setProject, projectConfiguratorObj],
  );

  return navigateToProject;
};
